// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const HighOnRentalDays = t.struct({
    highdayscount: t.Number
}, {
    name: 'HighOnRentalDays',
    strict: true
});

export const getDefaultState = () =>
    new HighOnRentalDays({
        highdayscount: 0
    });

export default HighOnRentalDays;



// WEBPACK FOOTER //
// ./src/product/shared/state/high-rental.js